export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8931.74f9ba70.jpg";